import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';
import extendUser from '../common/extendUser';
import toggleGhost from '../common/toggleGhost';

app.initializers.add('happydigital-ghost-user', () => {
  extendUser();

  // Add a "Ghost this user" control to the user-controls dropdown on profiles
  // and post menus. Admin-only. There is no unghost here — once ghosted, the
  // user vanishes from the forum entirely (even for admins), so unghosting is
  // done exclusively from the admin panel's ghost list.
  extend(UserControls, 'moderationControls', (items, user) => {
    if (!app.session.user || !app.session.user.isAdmin()) return;
    if (user === app.session.user) return;
    if (user.isGhost()) return;

    items.add(
      'ghost',
      <Button icon="fas fa-user-slash" onclick={() => toggleGhost(user, true)}>
        {app.translator.trans('happydigital-ghost-user.forum.controls.ghost')}
      </Button>,
      89
    );
  });
});
